import { render, staticRenderFns } from "./NewComerAdvanced.vue?vue&type=template&id=7a73c1c1&scoped=true"
import script from "./NewComerAdvanced.vue?vue&type=script&lang=js"
export * from "./NewComerAdvanced.vue?vue&type=script&lang=js"
import style0 from "./NewComerAdvanced.vue?vue&type=style&index=0&id=7a73c1c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a73c1c1",
  null
  
)

export default component.exports